import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { InlineSVGModule } from 'ng-inline-svg';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ngx-translate/core';

function SortBarComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵlistener("click", function SortBarComponent_button_13_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.sortByDefault(); });
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3, "Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SortBarComponent_button_14_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, option_r5.labelASC));
} }
function SortBarComponent_button_14_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, option_r5.labelDESC));
} }
function SortBarComponent_button_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵlistener("click", function SortBarComponent_button_14_div_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const option_r5 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.sortByProperty(option_r5, option_r5.order); });
    ɵngcc0.ɵɵtemplate(2, SortBarComponent_button_14_div_1_span_2_Template, 3, 3, "span", 20);
    ɵngcc0.ɵɵtemplate(3, SortBarComponent_button_14_div_1_span_3_Template, 3, 3, "span", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", option_r5.order === ctx_r6.sortOrderType.Ascending);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", option_r5.order === ctx_r6.sortOrderType.Descending);
} }
function SortBarComponent_button_14_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function SortBarComponent_button_14_ng_template_2_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.sortByProperty(option_r5, ctx_r19.sortOrderType.Descending); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, option_r5.labelDESC));
} }
function SortBarComponent_button_14_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function SortBarComponent_button_14_ng_template_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.sortByProperty(option_r5, ctx_r23.sortOrderType.Ascending); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, option_r5.labelASC));
} }
function SortBarComponent_button_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SortBarComponent_button_14_ng_template_2_div_0_Template, 4, 3, "div", 21);
    ɵngcc0.ɵɵtemplate(1, SortBarComponent_button_14_ng_template_2_div_1_Template, 4, 3, "div", 21);
} if (rf & 2) {
    const option_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", option_r5.order === ctx_r8.sortOrderType.Ascending);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", option_r5.order === ctx_r8.sortOrderType.Descending);
} }
function SortBarComponent_button_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵtemplate(1, SortBarComponent_button_14_div_1_Template, 4, 2, "div", 16);
    ɵngcc0.ɵɵtemplate(2, SortBarComponent_button_14_ng_template_2_Template, 2, 2, "ng-template", 17, 18, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const _r7 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !option_r5.shouldToggle)("ngIfElse", _r7);
} }
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["Ascending"] = 1] = "Ascending";
    SortOrder[SortOrder["Descending"] = -1] = "Descending";
})(SortOrder || (SortOrder = {}));

class SortBarComponent {
    constructor() {
        /** Adds a _Default_ sorting option to the sorting menu items. */
        this.displayDefaultSort = false;
        /** Event emitted when the _Default_ menu item has been selected. */
        this.defaultSortAction = new EventEmitter();
        this.sortOrderType = SortOrder;
    }
    ngOnInit() { }
    /**
     * Emits _defaultSortAction_.
     * This allows the parent component to reapply the default order, or to perform a more complex sorting algorithm.
     * Default button is not displayed unless _displayDefaultSort_ is set to true.
     * Dropdown needs to be closed manually to prevent fingertap glitches triggered by NgbDropdown autoClose.
     */
    sortByDefault() {
        this.optionSelected = '';
        this.defaultSortAction.emit();
        this.dropdown.close();
    }
    /**
     * Orders the itemList from the parent component based on the user selection.
     * @param selectedOption sorting option selected by the user, amongst the sortBarOptions set up from the parent component.
     * @param newOrder order selected by the user, Ascending or Descending.
     * Dropdown needs to be closed manually to prevent fingertap glitches triggered by NgbDropdown autoClose.
     */
    sortByProperty(selectedOption, newOrder) {
        selectedOption.order = newOrder;
        this.resetOptionSelected(selectedOption);
        this.toggleOrderSelection(selectedOption);
        this.orderByProperty(selectedOption);
        this.dropdown.close();
    }
    /**
     * Sets the order (_Ascending_/_Descending_) of the option according to the user's selection.
     * @param selectedOption sorting option selected by the user, amongst the sortBarOptions set up from the parent component.
     */
    toggleOrderSelection(selectedOption) {
        const x = this.sortBarOptions.find((option) => option === selectedOption);
        if (x) {
            x.order = selectedOption.order;
        }
    }
    /**
     * Sorts the itemList from the parent component by the property set up in sortBarOptions.
     * @param selectedOption sorting option selected by the user, amongst the sortBarOptions set up from the parent component.
     */
    orderByProperty(selectedOption) {
        this.itemList.sort((a, b) => {
            const x = a[selectedOption.propertyToSort];
            const y = b[selectedOption.propertyToSort];
            const comparison = isNaN(x) ? x.localeCompare(y) : x - y;
            return selectedOption.order * comparison;
        });
    }
    /**
     * Sets the _optionSelected_ property to the label set up in sortBarOptions.
     * @param selectedOption sorting option selected by the user, amongst the sortBarOptions set up from the parent component.
     * @param newOrder order selected by the user, Ascending or Descending.
     */
    resetOptionSelected(selectedOption) {
        switch (selectedOption.order) {
            case SortOrder.Ascending:
                this.optionSelected = selectedOption.labelASC;
                break;
            case SortOrder.Descending:
                this.optionSelected = selectedOption.labelDESC;
                break;
        }
    }
}
SortBarComponent.ɵfac = function SortBarComponent_Factory(t) { return new (t || SortBarComponent)(); };
SortBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SortBarComponent, selectors: [["fgbcl-sort-bar"]], viewQuery: function SortBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDropdown, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { displayDefaultSort: "displayDefaultSort", sortBarOptions: "sortBarOptions", itemList: "itemList" }, outputs: { defaultSortAction: "defaultSortAction" }, decls: 16, vars: 4, consts: [[1, "sort-bar", "col-12", "ml-2"], [1, "d-flex", "flex-row", "justify-content-between", "font-weight-bold"], [1, "sort-bar-title", "d-flex", "align-items-center"], ["ngbDropdown", "", "role", "group", 1, "d-flex", 3, "autoClose"], ["ngbDropdownToggle", "", 1, "nav-link", "btn", "text-black", "d-flex", "font-size-14", "align-items-center", "mx-2", "px-0", "justify-content-end", "dropdown-toggle"], ["aria-hidden", "true", 1, "icon", "material-icons", "pr-2"], ["ngbDropdownMenu", "", 1, "shadow", "text-center", "dropdown-menu", "dropdown-menu-right", "p-0", "sort-dropdown", "mt-2"], ["greedyDropdown", ""], [1, "d-flex", "flex-column"], ["type", "button", "class", "sort-bar-item dropdown-item text-black bg-white py-0 rounded", 4, "ngIf"], ["type", "button", "class", "sort-bar-item sort-bar-options dropdown-item text-black bg-white py-0 rounded", 4, "ngFor", "ngForOf"], [1, "border-bottom", "border-disabled", "mb-4", "w-100"], ["type", "button", 1, "sort-bar-item", "dropdown-item", "text-black", "bg-white", "py-0", "rounded"], [1, "dropdown-link", "px-3", 3, "click"], [1, "sort-bar-options"], ["type", "button", 1, "sort-bar-item", "sort-bar-options", "dropdown-item", "text-black", "bg-white", "py-0", "rounded"], ["class", "w-100 h-100", 4, "ngIf", "ngIfElse"], ["class", "w-100 h-100"], ["toggleBehavior", ""], [1, "w-100", "h-100"], [4, "ngIf"], ["class", "dropdown-link px-3", 3, "click", 4, "ngIf"]], template: function SortBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "All items");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtext(7, " sort ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "span");
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6, 7);
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵtemplate(13, SortBarComponent_button_13_Template, 4, 0, "button", 9);
        ɵngcc0.ɵɵtemplate(14, SortBarComponent_button_14_Template, 4, 2, "button", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "div", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("autoClose", "outside");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" Sort By: ", ctx.optionSelected, "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayDefaultSort);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sortBarOptions);
    } }, directives: [ɵngcc1.NgbDropdown, ɵngcc1.NgbDropdownToggle, ɵngcc1.NgbDropdownMenu, ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc3.TranslatePipe], styles: [".sort-bar[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:1.5rem}.sort-bar[_ngcontent-%COMP%]   .sort-bar-item[_ngcontent-%COMP%]{height:50px;cursor:pointer;padding:.25rem 0;display:flex;align-items:center;border:1px solid #f7f7f7}.sort-bar[_ngcontent-%COMP%]   .sort-bar-item[_ngcontent-%COMP%]:hover{background-color:#f7f7f7}.sort-bar[_ngcontent-%COMP%]   .dropdown-menu-right[_ngcontent-%COMP%]{right:.5rem;left:auto!important}.sort-bar[_ngcontent-%COMP%]   .sort-dropdown[_ngcontent-%COMP%]{margin-top:0;min-width:170px}.sort-bar[_ngcontent-%COMP%]   .dropdown-link[_ngcontent-%COMP%]{height:100%;width:100%;display:flex;align-items:center}"] });
SortBarComponent.ctorParameters = () => [];
SortBarComponent.propDecorators = {
    sortBarOptions: [{ type: Input }],
    itemList: [{ type: Input }],
    displayDefaultSort: [{ type: Input }],
    defaultSortAction: [{ type: Output }],
    dropdown: [{ type: ViewChild, args: [NgbDropdown,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortBarComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-sort-bar',
                template: "<div class=\"sort-bar col-12 ml-2\">\r\n  <div class=\"d-flex flex-row justify-content-between font-weight-bold\">\r\n    <div class=\"sort-bar-title d-flex align-items-center\">All items</div>\r\n\r\n    <div ngbDropdown class=\"d-flex\" [autoClose]=\"'outside'\" role=\"group\">\r\n      <button\r\n        class=\"nav-link btn text-black d-flex font-size-14 align-items-center mx-2 px-0 justify-content-end dropdown-toggle\"\r\n        ngbDropdownToggle\r\n      >\r\n        <span class=\"icon material-icons pr-2\" aria-hidden=\"true\"> sort </span>\r\n        <span> Sort By: {{ optionSelected }}</span>\r\n      </button>\r\n      <div ngbDropdownMenu class=\"shadow text-center dropdown-menu dropdown-menu-right p-0 sort-dropdown mt-2\" #greedyDropdown>\r\n        <div class=\"d-flex flex-column\">\r\n          <button type=\"button\" *ngIf=\"displayDefaultSort\" class=\"sort-bar-item dropdown-item text-black bg-white py-0 rounded\">\r\n            <div class=\"dropdown-link px-3\" (click)=\"sortByDefault()\">\r\n              <span class=\"sort-bar-options\">Default</span>\r\n            </div>\r\n          </button>\r\n          <button\r\n            type=\"button\"\r\n            *ngFor=\"let option of sortBarOptions\"\r\n            class=\"sort-bar-item sort-bar-options dropdown-item text-black bg-white py-0 rounded\"\r\n          >\r\n            <div class=\"w-100 h-100\" *ngIf=\"!option.shouldToggle; else toggleBehavior\">\r\n              <div class=\"dropdown-link px-3\" (click)=\"sortByProperty(option, option.order)\">\r\n                <span *ngIf=\"option.order === sortOrderType.Ascending\">{{ option.labelASC | translate }}</span>\r\n                <span *ngIf=\"option.order === sortOrderType.Descending\">{{ option.labelDESC | translate }}</span>\r\n              </div>\r\n            </div>\r\n            <ng-template class=\"w-100 h-100\" #toggleBehavior>\r\n              <div\r\n                *ngIf=\"option.order === sortOrderType.Ascending\"\r\n                class=\"dropdown-link px-3\"\r\n                (click)=\"sortByProperty(option, sortOrderType.Descending)\"\r\n              >\r\n                <span>{{ option.labelDESC | translate }}</span>\r\n              </div>\r\n              <div\r\n                *ngIf=\"option.order === sortOrderType.Descending\"\r\n                class=\"dropdown-link px-3\"\r\n                (click)=\"sortByProperty(option, sortOrderType.Ascending)\"\r\n              >\r\n                <span>{{ option.labelASC | translate }}</span>\r\n              </div>\r\n            </ng-template>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"border-bottom border-disabled mb-4 w-100\"></div>\r\n</div>\r\n",
                styles: [".sort-bar .icon{font-size:1.5rem}.sort-bar .sort-bar-item{height:50px;cursor:pointer;padding:.25rem 0;display:flex;align-items:center;border:1px solid #f7f7f7}.sort-bar .sort-bar-item:hover{background-color:#f7f7f7}.sort-bar .dropdown-menu-right{right:.5rem;left:auto!important}.sort-bar .sort-dropdown{margin-top:0;min-width:170px}.sort-bar .dropdown-link{height:100%;width:100%;display:flex;align-items:center}"]
            }]
    }], function () { return []; }, { displayDefaultSort: [{
            type: Input
        }], defaultSortAction: [{
            type: Output
        }], sortBarOptions: [{
            type: Input
        }], itemList: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: [NgbDropdown]
        }] }); })();

class SortBarModule {
}
SortBarModule.ɵfac = function SortBarModule_Factory(t) { return new (t || SortBarModule)(); };
SortBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SortBarModule });
SortBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            DirectivesModule,
            NgbDropdownModule,
            InlineSVGModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SortBarModule, { declarations: function () { return [SortBarComponent]; }, imports: function () { return [CommonModule,
        DirectivesModule,
        NgbDropdownModule,
        InlineSVGModule, ɵngcc3.TranslateModule]; }, exports: function () { return [SortBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortBarModule, [{
        type: NgModule,
        args: [{
                declarations: [SortBarComponent],
                imports: [
                    CommonModule,
                    DirectivesModule,
                    NgbDropdownModule,
                    InlineSVGModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [SortBarComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SortBarComponent, SortBarModule, SortOrder };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-sort-bar.js.map